import Vue from 'vue'
import Vuex from 'vuex'
import {updateData, clearData} from '@/libs/tools'

Vue.use(Vuex)

/**
 * [{oId: '111111', subject: '', soptions: '', rightResult: '', soptionsArr: ''}]
 */
export default new Vuex.Store({
  state: {
    loginState: false,
    allSubjectTableItem: []
  },
  getters: {
    getLoginState(state) {
      return state.loginState
    },
    getAllTableInfo(state) {
      return state.allSubjectTableItem
    },
    getTablesLength(state) {
      return state.allSubjectTableItem.length
    }
  },
  mutations: {
    changeLoginState(state, loginState) {
      state.loginState = loginState
    },
    addSingleTableInfo(state, singTable) {
      state.allSubjectTableItem.push(singTable)
    },
    clearSingleTableInfo(state, singTable) {
      state.allSubjectTableItem = clearData(state.allSubjectTableItem, singTable, 'oId')
    },
    updateSingleTable (state, tableInfo) {
      state.allSubjectTableItem = updateData(state.allSubjectTableItem, tableInfo, 'oId')
    },
    resetAllTableInfoes(state) {
      state.allSubjectTableItem = [];
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js